export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOG_OUT = "LOG_OUT";
export const SUBMITTED_USER_DETAILS = "SUBMITTED_USER_DETAILS";
export const EDITED_USER_DETAILS = "EDITED_USER_DETAILS";
export const DELETED_USER_DETAILS = "DELETED_USER_DETAILS";
export const GET_AVAILABLE_PICKUPS = "GET_AVAILABLE_PICKUPS";
export const GET_LISTED_PICKUPS = "GET_LISTED_PICKUPS";
export const GET_ACCEPTED_PICKUPS = "GET_ACCEPTED_PICKUPS";
export const SUBMITTED_PICKUP = "SUBMITTED_PICKUP";
export const DELETED_PICKUP = "DELETED_PICKUP";
export const ACCEPTED_PICKUP = "ACCEPTED_PICKUP";
export const ABANDONED_PICKUP = "ABANDONED_PICKUP";
export const EDITED_PICKUP = "EDITED_PICKUP";
export const TOKEN_CHECK_SUCCESS = "TOKEN_CHECK_SUCCESS";
export const TOKEN_CHECK_FAILURE = "TOKEN_CHECK_FAILURE";

